import { createStore, createHook } from 'react-sweet-state';

export type QueryCache<TData> = {
	[key: string]: TData;
};

const Store = createStore({
	initialState: {},
	actions: {
		setCacheEntry:
			<TData>(key: string, data: TData) =>
			({ setState }) => {
				setState({
					[key]: data,
				});
			},
	},
	name: 'useExperimentalQueryCache',
});

export const useExperimentalQueryCache = createHook(Store) as <TData>() => [
	QueryCache<TData>,
	{ setCacheEntry: (key: string, data: TData) => void },
];

// Export the store for direct access in non-hook contexts
export const queryCache = Store;
